/**
 * Explicit GT recommendation count from a location-like object (e.g. post payload
 * `post_locations[i].location`).
 *
 * Prefers `rec_count_breakdown.explicit_recommendations` (or `breakdown`) when that
 * object is present; if present but `explicit_recommendations` is missing/null, returns 0
 * per backend contract. When no breakdown object is present, falls back to
 * `rec_references.length` for legacy payloads.
 */
export function getExplicitRecBaseFromLocationData(locationData: unknown): number {
  if (!locationData || typeof locationData !== 'object') {
    return 0;
  }
  const loc = locationData as Record<string, unknown>;
  const raw = loc.rec_count_breakdown ?? loc.breakdown;
  if (raw !== undefined && raw !== null && typeof raw === 'object') {
    const ex = (raw as { explicit_recommendations?: unknown }).explicit_recommendations;
    if (typeof ex === 'number' && Number.isFinite(ex) && ex >= 0) {
      return Math.floor(ex);
    }
    return 0;
  }
  const refs = loc.rec_references ?? loc.recReferences;
  if (Array.isArray(refs) && refs.length > 0) {
    return refs.length;
  }
  return 0;
}
